<template>
  <div class="LKAsideMenu">
    <button
      :class="{ 'is-active': isActive }"
      class="aside__link mod--control w-inline-block text-lg-bold mod--aside LKAsideMenu__control"
      @click="isActive = !isActive"
      v-text="'Показать разделы'"
    />

    <LKToggleContainer
      :active="isActive"
      class="main__aside LKAsideMenu__container"
    >
      <div v-if="currentTopics.length > 0" @click="goBack">
        <LKAsideMenuSubmenuHeader
          :label="currentTopics[currentTopics.length - 1].name"
        />
      </div>

      <template v-for="item in currentMenu">
        <v-menu
          :key="item.id"
          open-on-hover
          offset-x
          content-class="LKAsideMenu__content"
        >
          <template #activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <LKAsideMenuItemTopicLK
                :label="item.name"
                :count="item.publications_count"
                :slug="item.slug"
                :children="item.children"
              />
            </div>
          </template>
          <v-list v-if="item.children.length > 0">
            <v-list-item
              v-for="subitem in item.children"
              :key="subitem.id"
              class="LKAsideMenu__list-item"
            >
              <LKAsideMenuItemTopicLK
                v-if="subitem.publications_count > 0"
                :key="subitem.id"
                :label="subitem.name"
                :count="subitem.publications_count"
                :slug="subitem.slug"
                :children="subitem.children"
              />
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <LKAsideMenuItem
        v-if="authorized && isSoop"
        label="Дорожные карты"
        :count="roadmapsCount"
        :loading="loadingRoadmapsCount"
        :to="LKRoadmapsFeedRoute"
      />
      <!-- <LKAsideMenuItem
        v-if="authorized && !isNiko && !isSod"
        label="Дорожные карты"
        :count="roadmapsCount"
        :loading="loadingRoadmapsCount"
        :to="LKRoadmapsFeedRoute"
      /> -->
      <!--
      <LKAsideMenuItem
        label="Архив"
        :count="0"
        to="#archive"
        disabled
      />
      -->
    </LKToggleContainer>
  </div>
</template>

<script>
import { LK_MUN_MEH_ROUTES } from '@/views/LKMunMeh/utils'
import { LK_ROADMAPS_FEED_ROUTES } from '@/views/LKRoadmapsFeed/utils'

import LKAsideMenuItem from './LKAsideMenu/LKAsideMenuItem.vue'
import LKAsideMenuItemTopicLK from './LKAsideMenu/LKAsideMenuItemTopicLK.vue'
import LKToggleContainer from '@/components/lk/LKToggleContainer.vue'
import LKAsideMenuSubmenuHeader from './LKAsideMenu/LKAsideMenuSubmenuHeader.vue'
import { LK_REG_MEH_ROUTES } from '@/views/LKRegMeh/utils'
import SiteDetectionMixin from '@/helpers/siteDetectionMixin'

export default {
  name: 'LKAsideMenu',
  components: {
    LKAsideMenuItem,
    LKAsideMenuItemTopicLK,
    LKToggleContainer,
    LKAsideMenuSubmenuHeader,
  },
  mixins: [SiteDetectionMixin],
  props: {
    topics: {
      type: Array,
      required: true,
    },
    authorized: {
      type: Boolean,
      required: true,
    },
    munMehCount: Number,
    regMehCount: Number,
    roadmapsCount: Number,
    loadingMunMehCount: Boolean,
    loadingRegMehCount: Boolean,
    loadingRoadmapsCount: Boolean,
  },
  data: () => ({
    isActive: false,
    currentTopics: [],
    LKRegMehRoute: {
      name: LK_REG_MEH_ROUTES.LAYOUT,
    },
    LKMunMehRoute: {
      name: LK_MUN_MEH_ROUTES.LAYOUT,
    },
    LKRoadmapsFeedRoute: {
      name: LK_ROADMAPS_FEED_ROUTES.LAYOUT,
    },
  }),
  computed: {
    visibleTopics() {
      return this.topics.filter(
        (topic) => topic.publications_count > 0 && !topic.is_hidden,
      )
    },
    currentMenu() {
      return this.currentTopics.length > 0
        ? this.currentTopics[this.currentTopics.length - 1].children
        : this.visibleTopics
    },
  },
  watch: {
    $route(to, from) {
      this.findTopicBySlug(this.currentMenu, to.params.topic_slug, from)
    },
  },
  created() {
    this.findTopicBySlug(this.currentMenu, this.$route.params.topic_slug)
  },
  methods: {
    findTopicBySlug(topics, slug) {
      for (let i = 0; i < topics.length; i += 1) {
        const topic = topics[i]
        if (topic.slug === slug) {
          if (
            this.currentTopics.length === 0
            || this.currentTopics[this.currentTopics.length - 1].slug !== slug
          ) {
            if (topic.children.length > 0) {
              this.currentTopics.push(topic)
              return topic
            }
          }
        }
        if (topic.children) {
          const result = this.findTopicBySlug(topic.children, slug)
          if (result) {
            this.currentTopics.unshift(topic)
            return result
          }
        }
      }
      return null
    },
    goBack() {
      this.currentTopics.pop()
      const parentTopic = this.currentTopics.length > 0
        ? this.currentTopics[this.currentTopics.length - 1]
        : this.visibleTopics[0]
      this.$router.push({
        name: LK_ROADMAPS_FEED_ROUTES.TOPIC,
        params: {
          slug: parentTopic.slug,
          topic_slug: parentTopic.slug,
        },
      })
    },
  },
}
</script>

<style lang="scss">
$bg-color: rgb(225, 235, 250);

.LKAsideMenu {
  position: relative;

  &__control {
    cursor: pointer;
    outline-style: none;
    transition: background-color 0.25s;

    &.is-active {
      background-color: $bg-color !important;
    }
  }

  &__container {
    display: block !important;

    &.is-active {
      margin-bottom: 15px;
    }

    &:not(.is-active) {
      @media screen and (min-width: 767px) {
        max-height: none !important;
      }
    }
  }

  &__list-item {
    display: unset !important;
    padding: 0;
    border-radius: 0;
  }

  &__content {
    border-radius: 0;
    box-shadow: 10px 10px 10px -4px $webflow-color-blue-dark-3;

    .v-list {
      padding: 0 !important;
      background-color: $webflow-color-blue-shadow !important;
    }
  }
}
</style>
